import React, { Component, Fragment } from "react";
import { Navigate } from "react-router-dom";
import { connect } from "react-redux";
import _ from 'lodash';

import {
  fetchMarketItems,
  fetchMarketItemsSuccess,
  fetchMarketItemsFailure,
  fetchGrades,
  fetchGradesSuccess,
  fetchGradesFailure,
} from "../../store/inventories/actions";
import {
  fetchOrderDetail,
  fetchOrderDetailSuccess,
  fetchOrderDetailFailure,
  fetchOrderDuplicate,
  fetchOrderDuplicateSuccess,
  fetchOrderDuplicateFailure,
  fetchBackOrderDetail,
  fetchBackOrderDetailSuccess,
  fetchBackOrderDetailFailure,
} from "../../store/orders/actions";
import {
  fetchShipment,
  fetchShipmentSuccess,
  fetchShipmentFailure,
  createShipmentForOrder,
  createShipmentForOrderSuccess,
  createShipmentForOrderFailure,
} from "../../store/shipments/actions";
import { fetchStations, fetchStationsSuccess, fetchStationsFailure } from "../../store/sessions/actions";

import {
  updateDeliveryDate,
  addItemToMarketOrder,
  deleteItemFromMarketOrder,
  updateItemInMarketOrder,
  sendMarketOrder,
  setInventoryReceived,
  completeOrderReceived,
  deleteMarketOrder,
} from "../../store/orders/api";

import { isPlantUser, isDeliveryUser } from "../../utils/AuthService";
import { orderStatusOptions } from "../../utils/Helpers";
import Alert from '../../utils/Alert';

import Modal from "../../components/generics/Modal";
import Spinner from "../../components/generics/Spinner";
import OrderEdit from '../../components/orders/OrderEdit';
import OrderDetail from "../../components/orders/OrderDetail";
import OrderInventoryDetail from "../../components/orders/OrderInventoryDetail";
import OrderDetailHeader from "../../components/orders/OrderDetailHeader";
import { withRouter } from "utils/WithRouter";

export class OrderDetailContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deliveryDate: {
        value: '',
        error: false,
      },
      searchQuery: '',
      station: undefined,
      itemListPage: 1,
      itemAmounts: Array(10).fill(1),
      itemPresentations: Array(10).fill('case'),
      itemGrades: [],
      errors: [],
      isUpdating: false,
      inventoryMapLoaded: false,
      receivedInventoryMap: {},
      currentPackage: undefined,
      currentPackageMissingInventories: {},
      openChangeCurrentPackageModal: false,
      inventoryToCheck: undefined,
      valueToCheck: undefined,
      receivedErrors: [],
      openFinishReceiveOrderModal: false,
      openDeleteModal: false,
      showItemsWithZeroQty: true,
      openNotFromThisMarketOrderModal: false,
    };

    this.alertRef = React.createRef();

    this.debounceSearch = _.debounce(this.searchItems, 300);
    this.debounceItemUpdate = _.debounce(this.handleOrderItemValueChange, 300);

  }

  componentDidMount() {
    this.props.fetchMarketOrderDetail(this.props.match.params.id);
    this.props.fetchBackOrder(this.props.match.params.id);
    this.props.fetchStations();
    this.props.fetchGrades();
    this.props.filterItems();
  }

  componentDidUpdate(prevProps) {
    if (this.props.newOrder && this.props.newOrder !== prevProps.newOrder && this.props.newOrder.newOrderId) {
      const newId = this.props.newOrder.newOrderId;
      this.props.fetchMarketOrderDetail(newId);
      // Clear old delivery date
      this.setState({
        deliveryDate: {
          value: '',
          error: false,
        }
      });
      this.props.history.push("/orders/" + newId);
    }
    if (this.props.order.order && this.props.order.order.id) {
      if (!prevProps.order.order || this.props.order.order.id !== prevProps.order.order.id) {
        const deliveryDate = this.props.order.order.delivery_date;
        this.setState({
          deliveryDate: {
            value: deliveryDate !== null ? deliveryDate : '',
            error: false,
          }
        });
        // If the order was loaded for the first time, and has already been shipped,
        // we fetch the shipment detail.
        if (this.props.order.order.shipment && this.props.order.order.status > 1) {
          this.props.fetchShipment(this.props.order.order.shipment);
          this.setState({ receivedInventoryMap: {}});
        }
      }
    }
    if (this.props.shipment.shipment && this.props.order.order &&
        this.props.shipment.shipment.id === this.props.order.order.shipment
        && this.props.order.order.status === 2 && !isPlantUser()
        && !this.state.inventoryMapLoaded) {
      const shipment = this.props.shipment.shipment;
      const receivedMap = _.flatMap(shipment.packages.map((pkg) => {
        return pkg.items.map((inventory) => {
          return { [inventory.id]: inventory.received_in_market }
        });
      })).reduce((result, current) => {
        return Object.assign(result, current);
      }, {});
      this.setState({
        receivedInventoryMap: receivedMap,
        inventoryMapLoaded: true,
      })
    }
  }

  orderAgain = () => {
    this.props.fetchMarketOrderDuplicate(this.props.match.params.id, this.alertRef);
  }


  // ---------------------------------------------------------------------------
  // Edit methods
  // ---------------------------------------------------------------------------
  searchItems = () => {
    const { searchQuery, station, itemListPage } = this.state;
    this.props.filterItems(searchQuery, station, itemListPage);
  };

  onSearchQueryChanged = (event) => {
    this.setState({
      searchQuery: event.target.value,
      itemListPage: 1,
      itemAmounts: Array(10).fill(1),
      itemPresentations: Array(10).fill('case'),
      itemGrades: [],
      errors: [],
      }, () => {
      this.debounceSearch();
    });
  }

  onStationChanged = (event) => {
    const station = event.target.value && event.target.value > -1 ? event.target.value : undefined;
    this.setState({
      station: station,
      itemListPage: 1,
      itemAmounts: Array(10).fill(1),
      itemPresentations: Array(10).fill('case'),
      itemGrades: [],
      errors: [],
    }, () => {
      this.debounceSearch();
    });
  }

  handleListItemValueChange = (inputType, index, item, newValue) => {
    this.setState((prevState => {
      // No default, should always match one of the declared types
      // eslint-disable-next-line default-case
      switch (inputType) {
        case 'amount': {
          const newAmountsValue = [...prevState.itemAmounts];
          newAmountsValue[index] = newValue;
          return {
            ...prevState,
            errors: [],
            itemAmounts: newAmountsValue,
          }
        }
        case 'presentation': {
          const newPresentationsValue = [...prevState.itemPresentations];
          newPresentationsValue[index] = newValue;
          return {
            ...prevState,
            errors: [],
            itemPresentations: newPresentationsValue,
          }
        }
        case 'grade': {
          const newGradesValues = [...prevState.itemGrades];
          newGradesValues[index] = newValue;
          return {
            ...prevState,
            errors: [],
            itemGrades: newGradesValues,
          }
        }
      }
    }));
  }

  addItemToOrder = (item, index) => {
    const { itemAmounts, itemPresentations, itemGrades } = this.state;
    let presentation = null;
    let grade = null;
    if (item.allows_grade_order) {
      grade = itemGrades[index];
    }
    if (!item.packs || !item.master_packing_number) {
      presentation = itemPresentations[index];
    }
    addItemToMarketOrder(this.props.match.params.id, {
      item: item.id,
      amount: itemAmounts[index],
      presentation,
      grade,
    }).then(response => {
      this.alertRef.current.sendAlert(`${item.name} has been added to the order`, "success");
      // Refresh Order
      this.props.fetchMarketOrderDetail(this.props.match.params.id);
      this.setState(prevState => {
        return {
          ...prevState,
          errors: [],
        }
      });
    }, ({ response }) => {
      if (response.status === 400) {
        const newErrors = [];
        newErrors[index] = response.data;
        this.setState(prevState => {
          return {
            ...prevState,
            errors: newErrors,
          }
        });
        if (typeof response.data === 'string') {
          this.alertRef.current.sendAlert(response.data);
        }
      }
    })
  }

  handleOrderItemValueChange = (inputType, itemId, item, newValue) => {
    this.setState({ isUpdating: true });

    updateItemInMarketOrder(itemId, {
      [inputType]: newValue,
    }).then(() => {
      // Refresh Order
      this.props.fetchMarketOrderDetail(this.props.match.params.id);
      this.setState({ isUpdating: false });
    }, () => {
      this.setState({ isUpdating: false });
    });
  }

  handleDeleteItem = (id) => {
    deleteItemFromMarketOrder(id).then(() => {
      // Refresh Order
      this.props.fetchMarketOrderDetail(this.props.match.params.id);
      this.alertRef.current.sendAlert(
        'Item was successfully removed from the order',
        "success"
      );
    }, () => {
      this.alertRef.current.sendAlert('The item could not be deleted')
    })
  }

  handleDeliveryDateChange = (event) => {
    const newDate = event.target.value;
    const orderId = this.props.match.params.id;
    this.setState({
      deliveryDate: {
        value: newDate,
        error: false,
      }
    })
    updateDeliveryDate(orderId, {
      delivery_date: newDate,
    })
    .then(() => {
      // Refresh Order
      this.props.fetchMarketOrderDetail(this.props.match.params.id);
    })
    .catch(() => {
      this.setState({
        deliveryDate: {
          value: newDate,
          error: true,
        }
      });
    });
  }

  handleOrderSubmit = () => {
    const orderId = this.props.match.params.id;
    sendMarketOrder(orderId).then(() => {
      this.alertRef.current.sendAlert('Your order has been successfully sent', "success");
      this.props.fetchMarketOrderDetail(orderId);
      this.props.history.push(`/orders/${orderId}`)
    }, (error) => {
      if (error.response && error.response.data) {
        if (error.response.data.delivery_date !== undefined) {
          this.setState((prevState) =>({
              deliveryDate: {
                value: prevState.deliveryDate.value,
                error: true,
              }
          }));
        } else if (error.response.data.no_items !== undefined) {
          this.alertRef.current.sendAlert(error.response.data.no_items)
        }
      }
    });
  }

  // ---------------------------------------------------------------------------
  // Pagination
  // ---------------------------------------------------------------------------
  handlePageRequest = (data) => {
    const page = data.selected + 1;
    if(page !== this.state.itemListPage){
      this.setState({ itemListPage: page }, () => {
          this.debounceSearch();
      });
    };
  }

  // ---------------------------------------------------------------------------
  // Go to Shipment
  // ---------------------------------------------------------------------------
  onShipmentClick = () => {
    const { order } = this.props.order;
    if (order.shipment !== null) {
      this.props.history.push(
        `/shipment/${order.shipment}${order.status === 1 ? '/edit' : ''}`);
    } else {
      this.props.createShipment(order.id, order.status, this.props);
    }
  }

  // ---------------------------------------------------------------------------
  // Marked received inventories
  // ---------------------------------------------------------------------------

  inventoriesLeftToMarkAsReceivedInPackage = (newPackageId) => {
    const { receivedInventoryMap, currentPackage } = this.state;
    let currentPackageMissingInventories = {};
    if (currentPackage && currentPackage !== newPackageId) {
      const packages = this.props.shipment.shipment.packages;
      const currentPackageIndex = _.findIndex(packages, (obj) => obj.id === currentPackage);
      const currentPackageInventories = packages[currentPackageIndex].items;
      const missingInventories = Object.keys(_.pickBy(receivedInventoryMap, (inventory) => !inventory));
      currentPackageMissingInventories = _.pickBy(
        currentPackageInventories,
        (inventory) => _.findIndex(missingInventories, (missingInventory) => missingInventory === String(inventory.id)) !== -1
      );
    }
    this.setState({ currentPackageMissingInventories });
    return currentPackageMissingInventories;
  };

  searchCurrentInventoryPackage = (inventoryId) => {
    const packages = this.props.shipment.shipment.packages;
    const currentPackage = _.find(packages, (obj) => _.find(obj.items, (item) => item.id === Number(inventoryId) || item.inventory_barcode === inventoryId));
    return currentPackage;
  };

  handleReceivedInventoryChanged = (inventoryId, value, skipChangePackageCheck, skipNotFromThisMarketOrderCheck, format = null, times = null, from_scanner=false) => {
    const currentInventoryPackage = this.searchCurrentInventoryPackage(inventoryId);
    const inventoryPackageId = currentInventoryPackage ? currentInventoryPackage.id : undefined;
    if (!skipChangePackageCheck) {
      const currentPackageMissingInventories = this.inventoriesLeftToMarkAsReceivedInPackage(inventoryPackageId);
      if (!_.isEmpty(currentPackageMissingInventories)) {
        this.setState({ inventoryToCheck: inventoryId, valueToCheck: value });
        this.setState({ openChangeCurrentPackageModal: true });
        return;
      }
    }
    this.setState({ currentPackage: inventoryPackageId });
    if (!currentInventoryPackage) {
      if (!skipNotFromThisMarketOrderCheck) {
        this.setState({ inventoryToCheck: inventoryId, valueToCheck: value });
        this.setState({ openNotFromThisMarketOrderModal: true });
        return;
      }
    }
    const { order } = this.props.order;
    const oldInventoryValue = this.state.receivedInventoryMap[inventoryId];
    let receivedErrors = [...this.state.receivedErrors];
    const invIndex = receivedErrors.indexOf(parseInt(inventoryId, 10));
    if (invIndex !== -1) {
      receivedErrors.splice(invIndex, 1);
    }
    this.setState(() => ({ receivedErrors }));
    setInventoryReceived(order.id, inventoryId, value, format, times, from_scanner).then(
      (response) => {
        if (response && response.data && response.data["not_ordered_inventory"]) {
          this.alertRef.current.sendAlert(response.data["not_ordered_inventory"], "warning");
        } else if (response && response.data && response.data["inventory_in_other_order"]) {
          this.alertRef.current.sendAlert(response.data["inventory_in_other_order"], "warning");
        } else if (value && oldInventoryValue) {
          this.alertRef.current.sendAlert(`Inventory #${inventoryId} was previously marked as received.`, "warning");
        } else if (response && response.data && response.data['barcode_inventories']) {
          const action = value ? 'marked as received' : 'unmarked'
          this.alertRef.current.sendAlert(`${response.data['barcode_inventories'].length} ${response.data['item']} has been ${action}.`, "success");
          response.data['barcode_inventories'].forEach(inv_id => {
            this.setState((prevState) => ({
              receivedInventoryMap: {
                ...prevState.receivedInventoryMap,
                [inv_id]: value,
              },
            }));
          });
        } else {
          const action = value ? 'marked as received' : 'unmarked'
          this.alertRef.current.sendAlert(`Inventory #${inventoryId} has been ${action}`, "success");
          this.setState((prevState) => ({
            receivedInventoryMap: {
              ...prevState.receivedInventoryMap,
              [inventoryId]: value,
            },
          }));
        }
      },
      (err) => {
        this.alertRef.current.sendAlert(err.response.data['error_msg'] || "Invalid inventory for order")
      }
    );
  }

  handleReceiveOrderFinishWithMarkedCheck = () => {
    const missingItems = Object.keys(_.pickBy(this.state.receivedInventoryMap, inventory => !inventory ))
    if (missingItems.length === 0) this.handleReceiveOrderFinish();
    else this.setState({ openFinishReceiveOrderModal: true });
  };

  handleReceiveOrderFinish = () => {
    const { order } = this.props.order;
    this.setState({
      receivedErrors: [],
    });
    completeOrderReceived(order.id).then(
      (response) => {
        this.props.setNewOrderData(response.data);
        this.alertRef.current.sendAlert("Order successfully received", "success");
        if (isDeliveryUser()) this.props.history.push('/orders/')
      },
      (error) => {
        const { message, ids: errorIds } = error.response.data;
        this.alertRef.current.sendAlert(message);
        this.setState({
          receivedErrors: errorIds,
        });
      }
    );
  };

  // ---------------------------------------------------------------------------
  // Delete Market Order
  // ---------------------------------------------------------------------------
  handleDeleteModal = () => {
    this.setState({ openDeleteModal: true });
  };

  handleDelete = () => {
    const orderId = this.props.match.params.id
    deleteMarketOrder(orderId).then(
      () => {
        this.alertRef.current.sendAlert(`Market Order #${orderId} has been deleted successfully`, "success");
        this.props.history.push('/orders')
      },
      () => {
        this.alertRef.current.sendAlert(`Market Order #${orderId} couldn't be deleted`);
      }
    );
    this.setState({ openDeleteModal: false })
  }

  messageToChangePackage = () => {
    const { currentPackageMissingInventories, currentPackage } = this.state;
    const message = (
      <div>
        <span>Inventories still missing in Package #{currentPackage} to mark as received:</span>
        {Object.keys(currentPackageMissingInventories).map((key) => {
          const inventory = currentPackageMissingInventories[key];
          return (
            <span key={key}>
              <br />- #{inventory.id}: {inventory.item.name}
            </span>
          );
        })}
        <br />
        <span>Proceed anyway?</span>
      </div>
    );
    return message;
  };

  messageWithMissingInventories = () => {
    const missingInventories = Object.keys(_.pickBy(this.state.receivedInventoryMap, inventory => !inventory ));
    const message = (
      <div>
        <span>There are items that were not marked as received:</span>
        {missingInventories.map((key) => {
          const packageInventories = this.searchCurrentInventoryPackage(Number(key)).items;
          const inventory = _.find(packageInventories, inv => inv.id === Number(key));
          return (
            <span key={key}>
              <br />- #{inventory.id}: {inventory.item.name}
            </span>
          );
        })}
        <br />
        <span>Proceed anyway?</span>
      </div>
    );
    return message;
  };

  toggleItemsWithZeroQty = () => {
    this.setState((prevState) => ({
      showItemsWithZeroQty: !prevState.showItemsWithZeroQty,
    }));
  };

  // ---------------------------------------------------------------------------
  // Render
  // ---------------------------------------------------------------------------
  render() {
    const { order, loading, error } = this.props.order;
    const {stationsList, itemsList, gradesList, backOrder, shipment} = this.props;

    const {
      deliveryDate,
      searchQuery,
      station,
      itemAmounts,
      itemPresentations,
      itemGrades,
      itemListPage,
      errors,
      isUpdating,
      receivedInventoryMap,
      receivedErrors,
    } = this.state;

    if (!order && !loading && error) {
      return <Navigate to="/orders" />;
    }

    if (!order) {
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <Spinner />
        </div>
      );
    }

    const isPlantUserValue = isPlantUser();

    // If order In Progress
    if (order.status === 0) {
      return (
        <Fragment>
          <Alert ref={this.alertRef}/>
          <OrderEdit
            order={order}
            deliveryDate={deliveryDate}
            searchQuery={searchQuery}
            station={station}
            stationOptions={stationsList.stations}
            onSearchQueryChanged={this.onSearchQueryChanged}
            onStationChanged={this.onStationChanged}
            handleOrderSubmit={this.handleOrderSubmit}
            handleDeliveryDateChange={this.handleDeliveryDateChange}
            itemList={itemsList}
            itemListPage={itemListPage}
            handleListPageChange={this.handlePageRequest}
            itemAmounts={itemAmounts}
            itemPresentations={itemPresentations}
            itemGrades={itemGrades}
            handleListItemValueChange={this.handleListItemValueChange}
            handleAddItem={this.addItemToOrder}
            errors={errors}

            isUpdating={isUpdating}
            handleOrderItemValueChange={this.debounceItemUpdate}
            handleDeleteItem={this.handleDeleteItem}

            grades={gradesList.grades.results}
          />
        </Fragment>
      )
    }

    const isReceivingOrder = order.status === 2 && !isPlantUserValue
    // If order was shipped and you are receiving it as a non plant user.
    const orderDetailComponent = isReceivingOrder ? (
      <div>
        <Modal
          closeModal={() => this.setState({ openFinishReceiveOrderModal: false })}
          isModalOpen={this.state.openFinishReceiveOrderModal}
          onConfirm={() => this.handleReceiveOrderFinish()}
          onCancel={() => this.setState({ openFinishReceiveOrderModal: false })}
          header="Warning!"
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        >
          {this.messageWithMissingInventories()}
        </Modal>
        <Modal
          closeModal={() => this.setState({ openChangeCurrentPackageModal: false })}
          isModalOpen={this.state.openChangeCurrentPackageModal}
          onConfirm={() => {
            this.handleReceivedInventoryChanged(this.state.inventoryToCheck, this.state.valueToCheck, true, false);
            this.setState({ openChangeCurrentPackageModal: false });
          }}
          onCancel={() => this.setState({ openChangeCurrentPackageModal: false })}
          header="Warning, attempting to change package!"
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        >
          {this.messageToChangePackage()}
        </Modal>
        <Modal
          closeModal={() => this.setState({ openNotFromThisMarketOrderModal: false })}
          isModalOpen={this.state.openNotFromThisMarketOrderModal}
          onConfirm={() => {
            this.handleReceivedInventoryChanged(this.state.inventoryToCheck, this.state.valueToCheck, true, true);
            this.setState({ openNotFromThisMarketOrderModal: false });
          }}
          onCancel={() => this.setState({ openNotFromThisMarketOrderModal: false })}
          header="Warning, this inventory is not from this shipment!"
          content="The inventory that you are checking as received is not from this shipment.
                   Would you like to proceed anyway?"
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        ></Modal>
        <OrderInventoryDetail
          order={order}
          backOrder={backOrder}
          shipment={shipment}
          receivedInventories={receivedInventoryMap}
          receivedErrors={receivedErrors}
          onReceivedInventoryChanged={this.handleReceivedInventoryChanged}
        />
      </div>
    ) : (
      <OrderDetail
        order={order}
        backOrder={backOrder}
        toggleItemsWithZeroQty={this.toggleItemsWithZeroQty}
        showItemsWithZeroQty={this.state.showItemsWithZeroQty}
      />
    )
    return (
      <div className="animated fadeIn">
        <Alert ref={this.alertRef}/>
        <Modal
          closeModal={() => this.setState({ openDeleteModal: false })}
          isModalOpen={this.state.openDeleteModal}
          onConfirm={() => this.handleDelete()}
          onCancel={() => this.setState({ openDeleteModal: false })}
          header="Delete Market Order"
          content={`Are you sure you want to delete Market Order #${this.props.match.params.id}?`}
          onConfirmButtonText="Yes"
          onCancelButtonText="No"
        />
        {order && (
          <OrderDetailHeader
            order={order}
            isReceivingOrder={isReceivingOrder}
            buttonAction={isReceivingOrder ? this.handleReceiveOrderFinishWithMarkedCheck : this.orderAgain}
            isPlantUser={isPlantUserValue}
            orderStatus={orderStatusOptions[order.status]}
            goToShipment={this.onShipmentClick}
            handleDelete={this.handleDeleteModal}
            showItemsWithZeroQty={this.state.showItemsWithZeroQty}
          />
        )}
        {order && orderDetailComponent}
        {loading ? <Spinner /> : null}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    order: state.orders.marketOrderDetail,
    stationsList: state.sessions.stationsList,
    gradesList: state.inventories.gradesList,
    itemsList: state.inventories.itemsList,
    newOrder: state.orders.marketOrderDuplicate,
    backOrder: state.orders.backOrderDetail,
    shipment: state.shipments.createEditShipment,
  };
};

const mapDispatchToProps = (dispatch) => {
  const alert = (notAvailable, alertRef) => {
    (notAvailable === 0)
      ? alertRef.current.sendAlert("The order has been successfully copied", "success")
      : alertRef.current.sendAlert("The order has been copied. Some items could not be added because they are no longer available", "warning");
  };
  const goToShipment = (id, orderStatus, props) => {
    props.history.push(`/shipment/${id}${orderStatus === 1 ? '/edit' : ''}`);
  };
  return {
    fetchMarketOrderDetail: (id) => {
      dispatch(fetchOrderDetail(id)).payload.then((response) => {
          dispatch(fetchOrderDetailSuccess(response.data));
        }, (error) => {
          dispatch(fetchOrderDetailFailure(error));
        }
      );
    },
    setNewOrderData: (data) => {
      dispatch(fetchOrderDetailSuccess(data));
    },
    filterItems: (query, station, page) => {
      dispatch(fetchMarketItems(query, station, page)).payload.then((response) => {
        dispatch(fetchMarketItemsSuccess(response.data))
      }, (error) => {
        dispatch(fetchMarketItemsFailure(error));
      });
    },
    fetchStations: () => {
      dispatch(fetchStations()).payload.then((response) => {
        dispatch(fetchStationsSuccess(response.data.results))
      }, (error) => {
        dispatch(fetchStationsFailure(error));
      });
    },
    fetchGrades: () => {
      dispatch(fetchGrades()).payload.then((response) => {
        dispatch(fetchGradesSuccess(response.data))
      }, (error) => {
        dispatch(fetchGradesFailure(error));
      });
    },
    fetchMarketOrderDuplicate: (id, alertRef) => {
      dispatch(fetchOrderDuplicate(id)).payload.then(
        (response) => {
          dispatch(fetchOrderDuplicateSuccess(response.data));
          alert(response.data.not_available, alertRef);
        },
        (error) => {
          dispatch(fetchOrderDuplicateFailure(error));
        }
      );
    },
    createShipment: (id, orderStatus, props) => {
      dispatch(createShipmentForOrder(id)).payload.then((response) => {
        dispatch(createShipmentForOrderSuccess(response.data))
        goToShipment(response.data.id, orderStatus, props);
      }, (error) => {
        dispatch(createShipmentForOrderFailure(error));
      })
    },
    fetchBackOrder: (id) => {
      dispatch(fetchBackOrderDetail(id)).payload.then((response) => {
        dispatch(fetchBackOrderDetailSuccess(response.data));
      }, (error) => {
        dispatch(fetchBackOrderDetailFailure(error));
      });
    },
    fetchShipment: (id) => {
      dispatch(fetchShipment(id)).payload.then((response) => {
        dispatch(fetchShipmentSuccess(response.data));
      }, (error) => {
        dispatch(fetchShipmentFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(OrderDetailContainer));
